import React, { useState, CSSProperties, memo, useCallback } from "react";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import RouteModal from "../../../Component/BasicComponents/Modal/RouteModal";
import { FaEdit, FaEye, FaPlus } from "react-icons/fa";
import PurposeModal from "./Modals/PurposeModal";

import { useAllPurpose } from "./hooks/useExpense";
type Props = {};

interface formData {
  title: string;
  Budget: string;
  Notes: string;
  purposeRole: string[];
  checkedItems: string[];
}

interface ApiReponse {
  Bgid?: number;
  GroupName?: string;
  groupcode?: string;
  status?: number;
  Status?: boolean;
  maxlimit?: number;
  notes?: string;
}

interface TableButtonProps {
  onClick: () => void;
  title?: string;
  style?: CSSProperties;
}

const TableButton: React.FC<TableButtonProps> = memo(
  ({ onClick, title = "Add Heads", style }) => {
    const defaultStyle: CSSProperties = {
      display: "flex",
      borderRadius: "20px",
      padding: "2px",
      width: "110px",
      height: "40px",
      justifyContent: "center",
      textAlign: "center",
      alignItems: "center",
    };

    return (
      <div>
        <button
          onClick={onClick}
          className="btn btn-info"
          style={{ ...defaultStyle, ...style }} // External styles override default
        >
          <FaPlus /> <span style={{ marginLeft: "5px" }}>{title}</span>
        </button>
      </div>
    );
  }
);

// Main start
const ExpensePurposeTable = (props: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mode, setMode] = useState<"add" | "edit" | "view" | null>(null);
  const [purposeBID, setPurposeBID] = useState<number | undefined>(undefined);

  const [formdata, setformData] = useState<formData>({
    title: "",
    Budget: "",
    Notes: "",
    purposeRole: [],
    checkedItems: [],
  });

  const PurposeRequestColumns = (handlePuroseRequestView: (row: any) => void,handlePurposeRequestEdit: (row: any) => void) => [
    {
      name: "Sr.",
      selector: (row: { Sr: number | string }) => row.Sr,
      maxWidth: "10%",
    },
    {
      name: "Title",
      selector: (row: { Title: string }) => row.Title || '-',
    },
    {
      name: "Notes",
      selector: (row: { Notes: string }) => row.Notes || '-',
    },
    {
      name: "Status",
      selector: (row: { Status: any }) => row.Status === 1 ?'Active' :'Inactive',
    },
    {
      name: "Budget",
      selector: (row: { Budget: string }) => row.Budget,
    },
    {
      name: "Actions",
      // width: "200px",
      cell: (row: any) => (
        <div style={{ display: "flex", gap: "4px" }}>
          <button
            onClick={() => handlePurposeRequestEdit(row)}
            className="btn btn-primary"
            style={{ borderRadius: "20px", padding: "5px", width: "80px" }}
          >
            <FaEdit style={{ fill: "#fff" }} size={16} /> Edit
          </button>
          <button
            onClick={() => handlePuroseRequestView(row)}
            className="btn btn-info"
            style={{ borderRadius: "20px", padding: "5px", width: "80px" }}
          >
            <FaEye size={18} style={{ fill: "#fff" }} /> View
          </button>
        </div>
      ),
    },
  ];

  const { data, isLoading, isSuccess } = useAllPurpose({ enable: true });

  const PurposeRequestData =
    isSuccess && Array.isArray(data?.data)
      ? data?.data.map((item: ApiReponse, index: number) => {
          return {
            Sr: index + 1,
            Bgid: item.Bgid,
            Title: item.GroupName,
            Notes: item.notes,
            Status: item.status,
            Budget: item.maxlimit,
          };
        })
      : [];

  const AddPurposehandler = useCallback(() => {
    setIsModalOpen(true);
    setMode("add");
  }, []);

  const purPosetoggleModal = () => setIsModalOpen(!isModalOpen);

  const handlePuroseRequestView = (row: any) => {
    setPurposeBID(row.Bgid);
    setformData({
      title: row.Title,
      Budget: row.Budget,
      Notes: row.notes,
      purposeRole: [],
      checkedItems: [],
    });
    setIsModalOpen(true);
    setMode("view");
  };

  const handlePurposeRequestEdit = (row: any) => {
    setPurposeBID(row.Bgid);
    setIsModalOpen(true);
    setMode("edit");
  };

  // console.log('PurposeRequestData',data);

  return (
    <div className="row mb-0">
      <div className="col-sm-12">
        <BasicDataTable
          Title="Purpose"
          showSpinner={isLoading}
          data={!isLoading ? PurposeRequestData : isLoading}
          columns={PurposeRequestColumns(
            handlePuroseRequestView,
            handlePurposeRequestEdit
          )}
          headerContent={
            <TableButton
              onClick={() => AddPurposehandler()}
              title="Add Purpose"
              style={{ width: "130px", marginRight: "8px" }}
            />
          }
        />
      </div>

      {/*Purpose Modal */}
      <RouteModal
        size="lg"
        isOpen={isModalOpen}
        toggle={purPosetoggleModal}
        title={
          mode === "edit"
            ? "Edit Purpose"
            : mode === "add"
            ? "Add Purpose"
            : "View Purpoe"
        }
        content={
          <PurposeModal
            mode={mode}
            BID={purposeBID}
            handleClose={() => setIsModalOpen(false)}
          />
        }
      />
    </div>
  );
};

export default ExpensePurposeTable;
